/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/HomeCalendar/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import styles from "./HomeCalendar.module.css";
import useHomeCalendar from "../../hooks/useHomeCalendar";
import HomeCalendarDayModal from "../../modals/HomeCalendarDayModal";
import CalendarHeader from "./CalendarHeader";
import CalendarGrid from "./CalendarGrid";

const HomeCalendar = () => {
  const { state, actions } = useHomeCalendar();

  return (
    <div className={styles.calendar}>
      <CalendarHeader state={state} actions={actions} />
      <CalendarGrid state={state} actions={actions} />
      {state.dayAgenda && (
        <HomeCalendarDayModal
          open
          date={state.selectedDay}
          items={state.dayAgenda.items}
          appointmentCount={state.dayAgenda.appointmentCount}
          onClose={actions.closeDayModal}
        />
      )}
    </div>
  );
};

export default HomeCalendar;
